import { Box, Tab, TabList, TabPanel, TabPanels, Tabs, useColorModeValue } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { servicesData } from "../assets/services";
import { Service } from "../global/types";
import ServicesCard from "../components/ServicesCard";

export default function EducationPage() {
    const [eduGovernmentServicesArray, setEduGovernmentServicesArray] = useState<Service[]>([]);
    const [eduEuropeanServicesArray, setEduEuropeanServicesArray] = useState<Service[]>([]);
    const [eduIndependentsServicesArray, setEduIndependentsServicesArray] = useState<Service[]>([]);
    const [eduInternationalServicesArray, setEduInternationalServicesArray] = useState<Service[]>([]);
    const [eduResearchServicesArray, setEduResearchServicesArray] = useState<Service[]>([]);
    const [eduGreekPublicUniServicesArray, setEduGreekPublicUniServicesArray] = useState<Service[]>([]);

    const getEduGovernmentServices = (): Service[] =>
        servicesData.filter((srv: Service) => srv.category === "ΕκπαιδοΚυβερνητικοί Οργανισμοί");

    const getEduEuropeanServices = (): Service[] =>
        servicesData.filter((srv: Service) => srv.category === "ΕκπαιδοΕυρωπαϊκοί Οργανισμοί");

    const getEduInternationalServices = (): Service[] =>
        servicesData.filter((srv: Service) => srv.category === "ΕκπαιδοΔιεθνείς Οργανισμοί");

    const getEduIndependentsServices = (): Service[] =>
        servicesData.filter((srv: Service) => srv.category === "ΕκπαιδοΑνεξάρτητες Αρχές");

    const getEduResearchServices = (): Service[] =>
        servicesData.filter((srv: Service) => srv.category === "ΕκπαιδοΕρευνητικοί Φορείς");

    const getEduGreekPublicUniServices = (): Service[] =>
        servicesData.filter((srv: Service) => srv.category === "ΕκπαιδοΕλληνικά Δημόσια Πανεπιστήμια");

    useEffect(() => {
        const governmentServicesList = getEduGovernmentServices();
        setEduGovernmentServicesArray(governmentServicesList);
    }, []);

    useEffect(() => {
        const europeanServicesList = getEduEuropeanServices();
        setEduEuropeanServicesArray(europeanServicesList);
    }, []);

    useEffect(() => {
        const internationalServicesList = getEduInternationalServices();
        setEduInternationalServicesArray(internationalServicesList);
    }, []);

    useEffect(() => {
        const independentsServicesList = getEduIndependentsServices();
        setEduIndependentsServicesArray(independentsServicesList);
    }, []);

    useEffect(() => {
        const researchServicesList = getEduResearchServices();
        setEduResearchServicesArray(researchServicesList);
    }, []);

    useEffect(() => {
        const greekPublicUniServicesList = getEduGreekPublicUniServices();
        setEduGreekPublicUniServicesArray(greekPublicUniServicesList);
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const tabColor = useColorModeValue("primary", "light");

    return (
        <Box>
            <Tabs variant="enclosed" colorScheme={tabColor}>
                <TabList flex="1">
                    <Tab fontWeight="bold">Κυβερνητικοί Οργανισμοί</Tab>
                    <Tab fontWeight="bold">Ευρωπαϊκοί Οργανισμοί</Tab>
                    <Tab fontWeight="bold">Διεθνείς Οργανισμοί</Tab>
                    <Tab fontWeight="bold">Ανεξάρτητες Αρχές</Tab>
                    <Tab fontWeight="bold">Ερευνητικοί Φορείς</Tab>
                    <Tab fontWeight="bold">Ελληνικά Δημόσια Πανεπιστήμια</Tab>
                </TabList>
                <TabPanels>
                    <TabPanel>
                        {eduGovernmentServicesArray.map((srv: Service) => {
                            return <ServicesCard inputService={srv} />;
                        })}
                    </TabPanel>
                    <TabPanel>
                        {eduEuropeanServicesArray.map((srv: Service) => {
                            return <ServicesCard inputService={srv} />;
                        })}
                    </TabPanel>
                    <TabPanel>
                        {eduInternationalServicesArray.map((srv: Service) => {
                            return <ServicesCard inputService={srv} />;
                        })}
                    </TabPanel>
                    <TabPanel>
                        {eduIndependentsServicesArray.map((srv: Service) => {
                            return <ServicesCard inputService={srv} />;
                        })}
                    </TabPanel>
                    <TabPanel>
                        {eduResearchServicesArray.map((srv: Service) => {
                            return <ServicesCard inputService={srv} />;
                        })}
                    </TabPanel>
                    <TabPanel>
                        {eduGreekPublicUniServicesArray.map((srv: Service) => {
                            return <ServicesCard inputService={srv} />;
                        })}
                    </TabPanel>
                </TabPanels>
            </Tabs>
        </Box>
    );
}